import React, { useCallback, useEffect, useState } from "react";
import { graphql, navigate, StaticQuery } from "gatsby";
import styled, { useTheme } from "styled-components";
import BBLogoBlue from "../assets/images/bb-logo-blue-cropped.png";
import { ContactNavLink } from "./LinkStyles";
import NotificationDot from "./NotificationDot";
import NavLink from "./NavLink";
import Switch from "./Switch";
import { MaxWidthContainer } from "./MaxWidthContainer";
import { LinkInternal } from "./LinkInternal";

const Header = ({
  toggleTheme,
  onClickScroll,
}: {
  toggleTheme: () => void;
  onClickScroll?: () => void;
}): JSX.Element => {
  const theme = useTheme();

  const [isVisible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(true);
  }, []);

  const goHomeFromReferral = useCallback(() => {
    // used older navigate method because passing state via Gatsby Link component was inconsistent
    navigate("/", { state: { referral: true } });
  }, []);

  const activeLinkStyles = {
    color: theme.colours.orange,
  };

  return (
    <nav>
      <MaxWidthContainer
        wideLayout
        style={{
          justifyContent: "space-between",
        }}
      >
        <NavRowContent>
          <LinkInternal to="/" ariaLabel="Clickable link to the Home page">
            <LogoStyles
              alt="Blue Beck logo"
              src={BBLogoBlue}
              darkTheme={theme.LightOrDark === "dark"}
            />
          </LinkInternal>
          <InteractiveElementsContainer>
            <NavLinksContainer>
              <NavLink to="/blog" activeStyle={activeLinkStyles} tabIndex={0}>
                Blog
              </NavLink>
              <StaticQuery
                query={query}
                render={(data) => {
                  if (!data) {
                    return null;
                  }
                  const totalJobs = data?.allStrapiJobs.totalCount;
                  return (
                    <NavLink
                      activeStyle={activeLinkStyles}
                      isCareers={totalJobs > 0}
                      to="/careers"
                      tabIndex={0}
                    >
                      Careers
                      {totalJobs > 0 && isVisible && (
                        <NotificationDot notificationNumber={totalJobs} />
                      )}
                    </NavLink>
                  );
                }}
              />
              <ContactNavLink
                onClick={onClickScroll || goHomeFromReferral}
                role="link"
                tabIndex={0}
              >
                Contact
              </ContactNavLink>
            </NavLinksContainer>
            <Switch
              showThemeIcons
              isToggled={theme.LightOrDark === "dark"}
              onToggle={toggleTheme}
            />
          </InteractiveElementsContainer>
        </NavRowContent>
      </MaxWidthContainer>
    </nav>
  );
};
const query = graphql`
  query {
    # filter out the dummy blank job, used to prevent Gatsby crash when no other Jobs set in Strapi
    # allStrapiJobs(filter: { jobTitle: { ne: "BlankJob" } }) {
    allStrapiJobs {
      totalCount
    }
  }
`;
const NavRowContent = styled.div`
  margin: 1rem auto 0 auto;
  width: 100%;

  display: flex;
  justify-content: space-between;
  @media (max-width: ${(props) => props.theme.screenSize.l}px) {
    margin: 1rem auto;
    padding: 0;
  }
`;
const LogoStyles = styled.img<{ darkTheme: boolean }>`
  height: 4rem;
  &:hover {
    cursor: pointer;
  }
`;
// Add the below styles to LogoStyles if white background needed for bb-logo-black.png
// background: ${(props) =>
//   props.darkTheme ? props.theme.colours.foreground : null};
// outline: ${(props) => (props.darkTheme ? 3 : 0)}px solid
//   ${(props) => (props.darkTheme ? props.theme.colours.foreground : null)};
const InteractiveElementsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  @media (max-width: ${(props) => props.theme.screenSize.m}px) {
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
  }
`;
const NavLinksContainer = styled.div`
  display: flex;
  align-items: center;
`;

export default Header;
